import { useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import questionService from '../../_services/question.service'
import { Modal } from 'react-bootstrap'
import classes from './ImageView.module.scss'
import { useSelector } from 'react-redux'
import { getTranslate } from '../Phrase/PhraseSlice'
import { showLoadingDialog } from '../../_helpers/util'

export default function ImageViewer(props) {
  const { imageId } = useParams()
  const [imageUrl, setImageUrl] = useState('')

  useEffect(() => {
    var url
    if (props.isLocal) {
      url = URL.createObjectURL(props.currentImage)
      setImageUrl(url)
    } else {
      var loading = showLoadingDialog()
      questionService
        .getquestionImage(props.currentImage.fileName) // آدرس API سرور
        .then((res) => {
          if (res.status && res.data?.content) {
            url = 'data:image/jpg;base64,' + res.data?.content
            setImageUrl(url)
          }
        })
        .finally(() => {
          loading.close()
        })
    }
  }, [props.currentImage, props.isLocal])

  var downloadTitle = useSelector(getTranslate('ImageViewer_DownloadImage'))
  return (
    <Modal
      show={props.isViewerOpen}
      onHide={props.onClosHandler}
      size='xl'
      aria-labelledby='example-modal-sizes-title-lg'
      className='addquestion-width'
      enforceFocus={false}
    >
      <Modal.Header closeButton className=' header-new-question-color'>
        <Modal.Title></Modal.Title>
      </Modal.Header>
      <Modal.Body className='add-question-body-color'>
        <div style={{ textAlign: 'center', padding: '2rem' }}>
          {imageUrl && (
            <>
              <img src={imageUrl} alt='full' style={{ maxWidth: '90%' }} />
              <br />
              <a href={imageUrl} download={`image-${imageId}.jpg`}>
                <button className={classes['download-button']}>
                  {downloadTitle}
                </button>
              </a>
            </>
          )}
        </div>
      </Modal.Body>
    </Modal>
  )
}
